// Veteran Topic 1 — Risk Management. Notes + infographics (scenes in scenes/advanced.jsx).
export default {
  title: 'Risk Management',
  summary: 'The rules that keep your account alive for years.',
  subtopics: [
    { title: 'Stop Loss', scene: 'vSl', cards: [
      { icon: '🛑', title: 'Put it where you are wrong', body: 'For a buy, below the swing low. For a sell, above the swing high.' },
      { icon: '📏', title: 'Add a buffer', body: 'Leave a few dollars extra on gold for spread and wicks.' },
      { icon: '🚫', title: 'Never move it further', body: 'Moving your stop away to "give it room" turns small losses into big ones.' },
      { icon: '🟡', title: 'Gold example', body: 'Buy at 2,360, swing low at 2,342. Stop at 2,340 — risk $20 per ounce.' },
    ] },
    { title: 'Position Size', scene: 'vSize', cards: [
      { icon: '🧮', title: 'The formula', body: 'Lot = money you will risk ÷ (stop distance in $ × 100) for gold.' },
      { icon: '⚖️', title: 'Stop first, lot second', body: 'Choose your stop from the chart, then work out the lot. Never the other way round.' },
      { icon: '📉', title: 'Round down', body: 'Always round the lot DOWN so you never risk more than planned.' },
      { icon: '🟡', title: 'Gold example', body: '$10,000 account, risk 1% = $100, stop $20 → 100 ÷ 2,000 = 0.05 lot.' },
    ] },
    { title: 'Risk-Reward Ratio', scene: 'vRR', cards: [
      { icon: '🎯', title: 'Aim for at least 1:2', body: 'Try to make at least twice what you risk.' },
      { icon: '🧠', title: 'Lose often, still win', body: 'With 1:2 you break even winning only about 1 in 3 trades.' },
      { icon: '📍', title: 'Realistic targets', body: 'Put your target before the next big SNR or zone, not at a dream price.' },
      { icon: '🟡', title: 'Gold example', body: 'Buy 2,380, stop 2,360 (risk $20), target 2,420 (reward $40) = 1:2.' },
    ] },
    { title: 'Never Risk More Than 1-2%', scene: 'v12', cards: [
      { icon: '🛡️', title: 'Small risk per trade', body: 'Risk only 1–2% of your account on any one trade.' },
      { icon: '🌧️', title: 'Losing streaks happen', body: 'Even great traders lose 5–10 in a row sometimes.' },
      { icon: '🧗', title: 'Big holes are hard to climb', body: 'Lose 50% and you need +100% just to get back.' },
      { icon: '😌', title: 'Calm mind', body: 'Small risk keeps you calm, so you follow your plan.' },
    ] },
  ],
};
